// @ts-nocheck
/* Browser-based wishlist (no app, no login).
   Stores wishlisted products in localStorage, reflects heart state on
   [data-wishlist-toggle] buttons, keeps [data-wishlist-count] badges in
   sync, and renders saved items into [data-wishlist-grid]. */
(function () {
  if (window.__kdWishlistInit) return;
  window.__kdWishlistInit = true;

  var KEY = 'kd_wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function indexOf(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return i;
    }
    return -1;
  }

  function has(id) {
    return indexOf(read(), id) !== -1;
  }

  function toggle(data) {
    var list = read();
    var i = indexOf(list, data.id);
    if (i === -1) {
      list.push(data);
    } else {
      list.splice(i, 1);
    }
    write(list);
    return i === -1;
  }

  function remove(id) {
    var list = read();
    var i = indexOf(list, id);
    if (i !== -1) {
      list.splice(i, 1);
      write(list);
    }
  }

  function dataFromBtn(btn) {
    return {
      id: btn.getAttribute('data-wishlist-id'),
      handle: btn.getAttribute('data-wishlist-handle'),
      title: btn.getAttribute('data-wishlist-title'),
      url: btn.getAttribute('data-wishlist-url'),
      image: btn.getAttribute('data-wishlist-image'),
      price: btn.getAttribute('data-wishlist-price')
    };
  }

  function paint(btn, on) {
    btn.classList.toggle('is-wishlisted', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function refreshButtons(root) {
    (root || document)
      .querySelectorAll('[data-wishlist-toggle]')
      .forEach(function (btn) {
        paint(btn, has(btn.getAttribute('data-wishlist-id')));
      });
  }

  function refreshCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c];
    });
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    var html = '';
    list.forEach(function (p) {
      var img = p.image
        ? '<img class="wishlist-card__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">'
        : '';
      html +=
        '<div class="wishlist-card">' +
        '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' +
        esc(p.id) +
        '" aria-label="Remove from wishlist">&times;</button>' +
        '<a class="wishlist-card__link" href="' +
        esc(p.url || '#') +
        '">' +
        '<div class="wishlist-card__media">' +
        img +
        '</div>' +
        '<div class="wishlist-card__title">' +
        esc(p.title) +
        '</div>' +
        '<div class="wishlist-card__price">' +
        esc(p.price) +
        '</div>' +
        '</a>' +
        '</div>';
    });
    grid.innerHTML = html;
  }

  function refreshAll(root) {
    refreshButtons(root);
    refreshCount();
    renderGrid();
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;
    renderGrid();
    drawer.removeAttribute('hidden');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      drawer.setAttribute('hidden', '');
    }, 280);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-wishlist-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(dataFromBtn(toggleBtn));
      paint(toggleBtn, added);
      toggleBtn.classList.remove('is-pop');
      void toggleBtn.offsetWidth;
      toggleBtn.classList.add('is-pop');
      refreshCount();
      renderGrid();
      return;
    }
    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn.getAttribute('data-wishlist-remove'));
      refreshAll();
    }
  });

  if (document.readyState !== 'loading') {
    refreshAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      refreshAll();
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    refreshAll(e.target);
  });
})();
